<template>
  <div>
    <div class="content">
      <div class="header-table">
        <table>
          <tbody>
            <tr>
              <td class="header-in-table">안전·보건 순회점검 개선조치 보고서</td>
              <td rowspan="2" class="th-background" style="width: 40px">결<br /><br />재</td>
              <td class="th-background" style="width: 120px">작성자</td>
              <td class="th-background" style="width: 120px">검토자</td>
              <td class="th-background" style="width: 120px">회람자</td>
              <td class="th-background" style="width: 120px">승인자</td>
            </tr>
            <tr>
              <td class="content-title" valign="bottom">1. 개요</td>
              <td class="signCell" :style="{ backgroundImage: typeof form.sign1 !== 'undefined' ? `url(${form.sign1.sign})` : '' }"></td>
              <td class="signCell" :style="{ backgroundImage: typeof form.sign2 !== 'undefined' ? `url(${form.sign2.sign})` : '' }"></td>
              <td class="signCell" :style="{ backgroundImage: typeof form.sign3 !== 'undefined' ? `url(${form.sign3.sign})` : '' }"></td>
              <td class="signCell" :style="{ backgroundImage: typeof form.sign4 !== 'undefined' ? `url(${form.sign4.sign})` : '' }"></td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="content-table">
        <table>
          <tbody>
            <tr>
              <th>학교(기관명)</th>
              <td colspan="3">{{ form.stdInfo.field_name }}</td>
              <th>지원청</th>
              <td colspan="3">{{ form.stdInfo.department }}</td>
            </tr>
            <tr>
              <th>작성자</th>
              <td colspan="3" style="border-right: none">{{ form.stdInfo.rank }}</td>
              <td colspan="4" style="border-left: none">{{ form.stdInfo.writer_name }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="content-table mt-28">
        <div class="content-title">2. 관리적요인 개선조치</div>
        <table style="margin-bottom: 12px;">
          <colgroup>
            <col />
            <col width="146" />
          </colgroup>
          <tbody>
          <tr>
            <th style="font-size: 14px;">개선조치 요구사항</th>
            <th style="font-size: 14px;">자체개선/조치보고</th>
          </tr>
          <tr v-for="row in form.managementList">
            <td style="font-size: 14px;">{{row.cell1}}</td>
            <td style="font-size: 14px;">{{row.cell2}}</td>
          </tr>
          </tbody>
        </table>
        <p style="color: #0079E9;text-align: center;">※ 조치보고 사항은 파일첨부하여 회신하여 주십시오.</p>
      </div>
      <div class="content-table mt-4 print-break-page"
           v-for="(_title, _title_i) in managementTitle"
           :key="`management_${_title}`"
           v-show="form.managementChecked.includes(_title)">
        <div class="content-title print-break-page"><i class="dot"></i> 현장 유해위험요인 개선조치({{_title}})</div>
        <report-plan
          class="mt-5"
          :reportPlan="form[`reportPlanList_${_title_i + 1}`]"
          :is-print="true"
          :readonly="true"
          :is-show-title="false"
          :report-type="_title_i + 1"
        />
      </div>

    </div>

  </div>
</template>

<script>
import TableInspectMerge from "@/components/TableInspectMerge.vue";
import DateSelector from "@/components/selector/DateSelector.vue";
import TableCustom from "@/components/TableCustom.vue";
import ReportPlan from "@/views/boards/single-page/677/ReportPlan.vue";
export default {
  name: "Print677",
  components: {ReportPlan, TableCustom, DateSelector, TableInspectMerge},
  props: {
    form: Object,
    board: Object,
  },
  data() {
    return {
      managementTitle: ["조치보고", "자체개선/조치보고", "우수사례"],
    };
  },
  methods: {
    getCheckBoxUrl(checked) {
      if (checked) {
        return `@/assets/images/print/print_check_checked.svg`;
      } else {
        return `@/assets/images/print/print_check_unchecked.svg`;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
$border-color: #cdcdcd;
.header {
  font-size: 24px;
  font-weight: bold;
  color: #000;
  text-align: center;
  padding: 20px 0;
}
.content {
  .content-title {
    font-size: 24px;
    font-weight: 700;
    line-height: 35px;
    margin-bottom: 14px;

    .dot {
      width: 20px;
      height: 20px;
      background-color: transparent;
      border: 1px solid #3c3c3c;
      border-radius: 0;
      display: inline-block;
      margin-top: 3px;
      margin-right: 10px;
    }
  }
  .header-table {
    table {
      width: 100%;
      border-collapse: collapse;
      tr:nth-child(1) {
        text-align: center;
        td {
          padding: 10px;
        }
        td:nth-child(n + 2) {
          font-size: 18px;
          font-weight: 500;
          border-left: 1px solid #cdcdcd;
          border-top: 1px solid #cdcdcd;
          border-right: 1px solid #cdcdcd;
        }
      }
      tr:nth-child(2) {
        height: 100px;
        td:nth-child(1) {
          padding-bottom: 15px;
        }
        td:nth-child(n + 2) {
          border-left: 1px solid #cdcdcd;
          border-top: 1px solid #cdcdcd;
          border-right: 1px solid #cdcdcd;
        }
      }
    }
    .header-in-table {
      font-size: 32px;
      font-weight: 700;
      line-height: 24px;
    }
    .signCell {
      background-position: center center;
      background-size: contain;
      background-repeat: no-repeat;
    }
  }
  .content-table {
    .sub-header,
    .item-label {
      padding: 14px;
      text-align: left;
      font-size: 18px;
    }
    .sub-header {
      font-weight: 700;
    }
    .row-title {
      font-weight: 500;
    }
    .row-title:before {
      content: "•";
      display: inline-block;
      width: 1em;
      margin-left: 1em;
    }
    table {
      width: 100%;
      table-layout: fixed;
      border-collapse: collapse;
      margin-bottom: 40px;

      th,
      td {
        border: 1px solid #cdcdcd;
        text-align: center;
        min-height: 55px;
        height: 55px;
        font-size: 18px;
      }
      th {
        background-color: #f9f9f9;
        font-weight: 500;
        padding: 0;
      }
      td {
        min-width: 50px;
        word-break: keep-all;
        img {
          display: inline-block;
        }
      }
      .check-container {
        padding: 10px 14px 0 14px;
        text-align: left;

        div {
          margin-bottom: 8px;
        }
        img {
          display: inline-block;
          margin-right: 8px;
        }
      }
      .text-left {
        text-align: left;
        padding: 10px 14px;
      }
    }

    /*서명 테이블*/
    .sign-table {
      th,
      td {
        font-size: 14px;
      }

      tr th:nth-child(1),
      tr td:nth-child(1),
      tr th:nth-child(8),
      tr td:nth-child(8) {
        width: 64px;
      }

      .signCell {
        white-space: nowrap;
        min-width: 90px;
        padding: 2px;
        height: 50px;
        background-position: center center;
        background-size: contain;
        background-repeat: no-repeat;
      }

      .signSpace {
        width: 10px;
        border-top: none;
        border-bottom: none;
      }
    }
  }

  .th-background {
    background-color: #f9f9f9;
    white-space: nowrap;
  }

  .print-break-page {
    page-break-before: always;
  }
}

.photoWrap {
  .photoContainer {
    display: flex;
    justify-content: center;
    width: 100%;
    border-radius: 6px;
    border: dashed 1px $border-color;
    break-inside: avoid;
  }
}
.photoWrap:nth-child(2n) {
}
.titleFull {
  font-size: 24px;
  font-weight: bold;
  text-align: center;
  width: 100%;
  height: 110px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
</style>

<style lang="scss">
.table-inspect-merge-print {
  h5 {
    font-size: 24px;
    font-weight: 700;
    line-height: 35px;
    color: #3c3c3c;

    display: flex;
    align-items: center;

    .dot {
      width: 20px;
      height: 20px;
      background-color: transparent;
      border: 1px solid #3c3c3c;
      border-radius: 0;
      display: inline-block;
      margin-top: 3px;
      margin-right: 14px;
    }
  }

  .print-textarea,
  .print-input {
    border: none;
    border-radius: 0;
  }

  table {
    th,
    td {
      border: 1px solid #757575 !important;
      min-height: 55px !important;
      height: 55px !important;
      font-size: 18px !important;
      text-align: center !important;
    }
    th {
      background-color: #ececec !important;
      font-weight: 500 !important;
      padding: 0 !important;
    }

    .title-tr > td {
      background-color: #ececec !important;
      text-align: left !important;
    }

    .content[colspan='4'],
    .content[colspan='7']{
      padding: 0 !important;

      & > div {
        display: grid !important;
        grid-template-columns: auto 1fr;
        gap: 0 !important;
      }
      p {
        flex: none ;
        padding: 0.7rem !important;
        width: 140px !important;
        height: 100% !important;
        display: flex;
        justify-content: center;
        align-items: center;
      }

      span {
        margin: 0 !important;
        border-left: 1px solid #757575 !important;
        white-space: pre-wrap;

        display: grid;
        align-items: center;
      }
    }
  }
}
</style>
